import { PromoCodeCreate } from "./promoCodeCreate";
import { PromoCodeEdit } from "./promoCodeEdit";
import { PromoCodeList } from "./promoCodeList";

export default {
	create: PromoCodeCreate,
	edit: PromoCodeEdit,
	list: PromoCodeList,
};
